module.exports = "/src/views/player/documets/ems/images/serial.png";